import { useEffect } from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import { useAuth } from "./lib/auth";
import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import CaseView from "./pages/CaseView";
import ChatSearch from "./pages/ChatSearch";
import Activity from "./pages/Activity";
import AdminAiUsage from "./pages/AdminAiUsage";
import AdminModels from "./pages/AdminModels";
import AdminGenerateDemo from "./pages/AdminGenerateDemo";
import AdminOrganizations from "./pages/AdminOrganizations";
import AdminUsers from "./pages/AdminUsers";
import AdminTimeEntries from "./pages/AdminTimeEntries";
import AdminTiers from "./pages/AdminTiers";
import AdminBilling from "./pages/AdminBilling";
import AdminInvoices from "./pages/AdminInvoices";
import AdminUsage from "./pages/AdminUsage";
import Credits from "./pages/Credits";
import MyTimeEntries from "./pages/MyTimeEntries";
import AppShell from "./components/AppShell";

function Protected({ children }: { children: JSX.Element }) {
  const { token } = useAuth();
  if (!token) return <Navigate to="/login" replace />;
  return children;
}

export default function App() {
  // Refresh the cached user from /auth/me on every app load so that fields
  // added to the user payload after the user originally logged in (e.g. email)
  // get populated without forcing a re-login.
  const hydrate = useAuth((s) => s.hydrate);
  useEffect(() => {
    void hydrate();
  }, [hydrate]);

  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route
        path="/*"
        element={
          <Protected>
            <AppShell>
              <Routes>
                <Route path="/" element={<Dashboard />} />
                <Route path="/cases/:caseId" element={<CaseView />} />
                <Route path="/cases/:caseId/chats" element={<ChatSearch />} />
                <Route path="/time" element={<MyTimeEntries />} />
                <Route path="/credits" element={<Credits />} />
                <Route path="/activity" element={<Activity />} />
                <Route path="/admin/users" element={<AdminUsers />} />
                <Route path="/admin/organizations" element={<AdminOrganizations />} />
                <Route path="/admin/time" element={<AdminTimeEntries />} />
                <Route path="/admin/models" element={<AdminModels />} />
                <Route path="/admin/ai-usage" element={<AdminAiUsage />} />
                <Route path="/admin/tiers" element={<AdminTiers />} />
                <Route path="/admin/billing" element={<AdminBilling />} />
                <Route path="/admin/usage" element={<AdminUsage />} />
                <Route path="/admin/invoices" element={<AdminInvoices />} />
                <Route path="/admin/generate-demo" element={<AdminGenerateDemo />} />
                <Route path="*" element={<Navigate to="/" replace />} />
              </Routes>
            </AppShell>
          </Protected>
        }
      />
    </Routes>
  );
}
